import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renders AI markdown as clean, calm formatted text (headings, bold, bullets).
export function AIText({ children, className = "" }) {
  const text = typeof children === "string" ? children : "";
  return (
    <div className={`aitext text-sm text-slate-700 leading-relaxed ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h3 className="font-display text-lg font-semibold text-navy mt-4 mb-1.5 first:mt-0" {...p} />,
          h2: ({ node, ...p }) => <h3 className="font-display text-base font-semibold text-navy mt-4 mb-1.5 first:mt-0" {...p} />,
          h3: ({ node, ...p }) => <h4 className="font-semibold text-navy mt-3 mb-1 first:mt-0" {...p} />,
          p: ({ node, ...p }) => <p className="mb-2.5 last:mb-0" {...p} />,
          ul: ({ node, ...p }) => <ul className="mb-2.5 space-y-1 pl-1" {...p} />,
          ol: ({ node, ...p }) => <ol className="mb-2.5 space-y-1 list-decimal pl-5" {...p} />,
          li: ({ node, children, ...p }) => (
            <li className="flex gap-2" {...p}><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brandteal" /><span className="flex-1">{children}</span></li>
          ),
          strong: ({ node, ...p }) => <strong className="font-semibold text-navy" {...p} />,
          a: ({ node, ...p }) => <a className="text-brandblue underline" target="_blank" rel="noreferrer" {...p} />,
          code: ({ node, ...p }) => <code className="rounded bg-slate-100 px-1 py-0.5 text-[13px]" {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-slate-200 pl-3 text-slate-500 italic mb-2.5" {...p} />,
          table: ({ node, ...p }) => <div className="overflow-x-auto mb-2.5"><table className="w-full text-left border-collapse" {...p} /></div>,
          th: ({ node, ...p }) => <th className="border-b border-slate-200 py-1.5 pr-3 font-semibold text-navy" {...p} />,
          td: ({ node, ...p }) => <td className="border-b border-slate-100 py-1.5 pr-3" {...p} />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
